import { render } from "./Bast.vue?vue&type=template&id=08fa9490"
import script from "./Bast.vue?vue&type=script&lang=js"
export * from "./Bast.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niq/Documents/Project Apps/TMI/Helpdesk App/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__